import React from 'react'
import GalleryMasterBanner from '../../components/galleryMaster/galleryMasterBanner'
import Header from "../../shared/header"
import PagesFooter from "../../shared/pagesFooter"
const GalleryMasterPage = () => {
    return (
        <div>
            <div className='gallery-header'>
                <Header />
            </div>
            <GalleryMasterBanner />
            <PagesFooter />
        </div>
    )
}

export default GalleryMasterPage